import { render, staticRenderFns } from "./MasterTipeBarang.vue?vue&type=template&id=1d8da0c3&"
import script from "./MasterTipeBarang.vue?vue&type=script&lang=js&"
export * from "./MasterTipeBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports